// validate forms
const ClientId = getCookiesOfGa();
let endpointUrlLead = "https://dev.formsubmissions.neoito.com/lead";

// logic for landing URL and referral path
// Referrer URL
let referrerURL = document.referrer;

// Current URL
let currentURL = window.location.href;

// Check if the 'firstLandedPage' cookie exists
let firstLandedPage = getCookieofLP("firstLandedPagenws");

// If the cookie doesn't exist, set it to the current page's URL
if (!firstLandedPage) {
  setCookieofLP("firstLandedPagenws", document.location.href, 1);
  firstLandedPage = document.location.href;
}

// console.log("First landed page: " + firstLandedPage);

// Function to get the value of a cookie
function getCookieofLP(name) {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name + "=") === 0) {
      return cookie.substring(name.length + 1, cookie.length);
    }
  }
  return null;
}

// Function to set the value of a cookie
function setCookieofLP(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + "; path=/";
}

function getCookiesOfGa() {
  let name = "_ga=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
}
// console.log(ClientId,referrerURL,currentURL,firstLandedPage);

jQuery(document).ready(function ($) {
  // contact us page

  $.validator.addMethod(
    "customEmail",
    function (value, element) {
      // Replace the regular expression with your desired pattern
      var emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      return this.optional(element) || emailPattern.test(value);
    },
    "Please enter a valid email address."
  );

  $("#contact-form").validate({
    rules: {
      firstname: "required",
      lastname: "required",
      email: {
        required: true,
        email: true,
        customEmail: true,
      },
      phone: {
        digits: true,
        minlength: 10,
      },
      comments: "required",
    },
    messages: {
      firstname: "First name is required.",
      lastname: "Last name is required.",
      email: {
        required: "Email is required.",
        email: "Please enter a valid email address.",
      },
      phone: {
        required: "Phone number is required.",
        digits: "Please enter a valid phone number.",
        minlength: "Please enter a valid phone number.",
      },
      comments: "Project description is required.",
    },
    submitHandler: function (form) {
      event.preventDefault();
      // Access field data in the submit handler
      var firstname = this.currentForm.elements.firstname.value;
      var lastname = this.currentForm.elements.lastname.value;
      var email = this.currentForm.elements.email.value;
      var phone = this.currentForm.elements.phone.value;
      var project_description = this.currentForm.elements.comments.value;

      // Prepare the request body
      var requestBody = JSON.stringify({
        client: {
          firstname: firstname,
          lastname: lastname,
          email: email,
          phone: phone,
          Project_Description: project_description,
          ClientId: ClientId,
          ReferrerURL: referrerURL,
          currentURL: currentURL,
          LandedPage: firstLandedPage,
        },
        neoito: {
          emailIds: ["marketing@neoito.com"],
          mailSubjectToTeam: "New Lead from Neoito Site",
        },
        isHubspot: true,
      });

      // Send the API request
      var requestOptions = {
        method: "POST",
        headers: {
          // authority: "formsubmissions.neoito.com",
          // accept: "*/*",
          // "accept-language": "en-US,en;q=0.9",
          // origin: "https://www.neoito.com",
          // referer: "https://www.neoito.com/",
          "Content-Type": "application/json",
        },
        body: requestBody,
        redirect: "follow",
      };

      fetch(endpointUrlLead, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          // Display success message
          $(".success-message-contact").text("Form send successful!");

          // Clear the form
          $("#contact-form,#casestudies-form")[0].reset();

          const site_url = window.location.origin;
          window.location.replace(site_url + "/thankyou/");

          // console.log(result);
        })
        .catch((error) => {
          // Display error message
          $(".error-message-contact").text(
            "An error occurred. Please try again later."
          );
          // console.log("error", error);
        });
    },
  });
});

function isValidEmail(email) {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  if (emailRegex.test(email)) {
    return true;
  } else {
    return false;
  }
}
